<div class="assign-list-wrapper">
  <div class="message error" *ngIf="!isAuthenticated">Please log in first.</div>

  <section *ngIf="isAuthenticated" class="list-content">
    <div class="message info" *ngIf="isLoading">{{ status }}</div>
    <div class="message error" *ngIf="error">{{ error }}</div>

    <app-entity-list
      *ngIf="!error"
      [loading]="isLoading"
      [list]="mappingList"
      [deletedMode]="deletedMode"
      [tableHeaderAndValueKeySets]="tableHeaderAndValueKeySets"
      [emptyMessage]="'No assigned flat found.'"
      [menuActions]="assignMenuActions"
      (cardClick)="onCardClickFromList($event)"
      (editClick)="onEditClickFromList($event)"
      (deleteClick)="onDeleteClickFromList($event)"
      (loadMore)="onLoadMoreFromList()"
    ></app-entity-list>
  </section>

  <app-detail-assign
    [visible]="isDetailsOpen"
    [mapping]="selectedMapping"
    (close)="closeDetailsModal()"
  ></app-detail-assign>

  <app-new-edit-assign
    *ngIf="isEditOpen"
    [mode]="selectedMapping ? 'edit' : 'create'"
    [initialMapping]="selectedMapping"
    [preselectedRenter]="preselectedRenter"
    (close)="closeEditModal()"
    (save)="onEditSave($event)"
    (editDocuments)="openEditDocumentsModal()"
  ></app-new-edit-assign>

  <div class="modal-overlay upload-overlay" *ngIf="isUploadModalOpen" (click)="skipUploadModal()">
    <div class="details-modal upload-modal" (click)="$event.stopPropagation()">
      <button class="close-icon" type="button" [attr.aria-label]="'common.close' | t:'Close'" (click)="skipUploadModal()">&times;</button>
      <h3>{{ uploadMode === 'edit' ? ('assign.uploadModalEditTitle' | t:'Edit Additional Documents') : ('assign.uploadModalCreateTitle' | t:'Upload Additional Documents') }}</h3>
      <p class="upload-hint">{{ 'assign.uploadHint' | t:'Optional: You can skip this step and upload later.' }}</p>
      <p class="upload-hint">{{ 'assign.uploadDocumentInfo' | t:'Upload agreement, NID, or any other relevant document for this flat assignment.' }}</p>
      <p class="upload-hint subtle">{{ 'assign.imageOptimizationInfo' | t:'Image files will be compressed aggressively to target about 1 MB while keeping them readable. PDF files stay unchanged.' }}</p>
      <p class="upload-hint subtle">{{ 'common.allowed' | t:'Allowed' }}: {{ assignmentAllowedExtensionsText }} | {{ 'assign.maxFiles' | t:'Max' }}: {{ assignmentMaxFileCount }} {{ 'assign.files' | t:'files' }}</p>

      <div class="upload-existing" *ngIf="uploadExistingAttachments.length > 0">
        <div class="upload-count">{{ 'assign.existingFiles' | t:'Existing file(s)' }}</div>
        <div class="upload-files">
          <div class="upload-file" *ngFor="let file of uploadExistingAttachments; let i = index">
            <button
              type="button"
              class="existing-file-link"
              (click)="openAttachmentPreview(file)"
            >
              {{ file.attachmentFileName || ('Document #' + file.id) }}
            </button>
            <button type="button" class="remove-file" (click)="removeExistingAttachment(i)">{{ 'common.remove' | t:'Remove' }}</button>
          </div>
        </div>
      </div>

      <label class="upload-picker">
        <input
          type="file"
          multiple
          accept=".jpg,.jpeg,.png,.pdf"
          [disabled]="isPreparingUploadFiles || isUploadingAttachment"
          (change)="onUploadFilesSelected($event)"
        />
        <span>{{ 'assign.selectFiles' | t:'Select File(s)' }}</span>
      </label>

      <div class="upload-selected" *ngIf="uploadFiles.length > 0; else noUploadFile">
        <div class="upload-count">{{ uploadFiles.length }} {{ 'assign.filesSelected' | t:'file(s) selected' }}</div>
        <div class="upload-files">
          <div class="upload-file" *ngFor="let file of uploadFiles; let i = index">
            <div class="upload-file-body">
              <span class="name">{{ file.name }}</span>
              <ng-container *ngIf="uploadFileInsight(file) as insight; else regularFileMeta">
                <div class="upload-file-size-row">
                  <span class="upload-size-chip">Original {{ formatFileSize(insight.originalSize) }}</span>
                  <span class="upload-size-chip accent" *ngIf="insight.compressedSize !== null">Compressed {{ formatFileSize(insight.compressedSize) }}</span>
                  <span class="upload-size-chip muted" *ngIf="insight.isPreparing">Estimating compressed size...</span>
                </div>
                <div class="upload-file-warning" *ngIf="insight.message">{{ insight.message }}</div>
              </ng-container>
              <ng-template #regularFileMeta>
                <div class="upload-file-size-row">
                  <span class="upload-size-chip">File {{ formatFileSize(file.size) }}</span>
                </div>
              </ng-template>
            </div>
            <button type="button" class="remove-file" (click)="removeUploadFile(i)">{{ 'common.remove' | t:'Remove' }}</button>
          </div>
        </div>
      </div>
      <ng-template #noUploadFile>
        <div class="upload-empty">{{ 'assign.noFilesSelected' | t:'No files selected.' }}</div>
      </ng-template>

      <div class="message" *ngIf="isPreparingUploadFiles">{{ 'common.preparing' | t:'Preparing files...' }}</div>
      <div class="message error" *ngIf="uploadError">{{ uploadError }}</div>
      <div class="details-actions upload-actions">
        <button type="button" class="SecondaryBTN" (click)="skipUploadModal()">{{ 'common.skip' | t:'Skip' }}</button>
        <button type="button" class="PositiveBTN" (click)="uploadAssignmentDocuments()" [disabled]="isUploadingAttachment || isPreparingUploadFiles">
          {{ (isUploadingAttachment || isPreparingUploadFiles) ? ('common.saving' | t:'Saving...') : (uploadMode === 'edit' ? ('assign.saveDocuments' | t:'Save Documents') : ('common.uploadingAction' | t:'Upload')) }}
        </button>
      </div>
    </div>
  </div>

  <div class="modal-overlay preview-overlay" *ngIf="isImagePreviewOpen" (click)="closeImagePreview()">
    <div class="details-modal image-preview-modal" (click)="$event.stopPropagation()">
      <button class="close-icon" type="button" [attr.aria-label]="'common.close' | t:'Close'" (click)="closeImagePreview()">&times;</button>
      <button class="preview-download-btn" type="button" (click)="downloadPreviewImage()">{{ 'common.download' | t:'Download' }}</button>
      <h3>{{ imagePreviewName || ('common.preview' | t:'Preview') }}</h3>
      <img *ngIf="imagePreviewUrl" [src]="imagePreviewUrl" [alt]="imagePreviewName || 'Attachment preview'" class="preview-image" />
    </div>
  </div>

  <app-confirm-action-modal
    [visible]="!!pendingDeleteMapping"
    [title]="'assign.deleteTitle' | t:'Delete Assigned Flat'"
    [message]="'assign.deleteMessage' | t:'Delete this assigned flat mapping?'"
    [confirmLabel]="'action.delete' | t:'Delete'"
    [isLoading]="isDeleting"
    [danger]="true"
    (cancel)="closeDeleteModal()"
    (confirm)="confirmDeleteMapping()"
  ></app-confirm-action-modal>

  <app-confirm-action-modal
    [visible]="pendingDeleteOnlyUpload"
    [title]="'action.delete' | t:'Delete'"
    [message]="'assign.deleteExistingDocumentConfirm' | t:'Do you want to delete this existing server file without uploading a new one?'"
    [confirmLabel]="'action.delete' | t:'Delete'"
    [danger]="true"
    (cancel)="closeDeleteOnlyUploadModal()"
    (confirm)="confirmDeleteOnlyUpload()"
  ></app-confirm-action-modal>
</div>
